/**
 *  Main Menu Json
 */
export default [
   {
      "menu_title": "Home",
      "path": "/home",
      "icon": "home"
   },
   {
      "menu_title": "Projects",
      "path": "/projects",
      "mega": true,
      "icon": "arrow_right_alt",
      "type": "subMenu",
      "child_routes": [
         {
            "path": "/projects",
            "menu_title": "My Projects",
            "icon": "arrow_right_alt",
            "child_routes": null
         }

      ]
   }
]
